function closeVideoModal() {
	$(".video-modal, .video-modal__overlay").fadeOut();
	setTimeout(() => {
		$(".video-modal__iframe-wrapper").html("");
	}, 500);
}

$(document).ready(function () {
	function openVideo(e) {
		e.preventDefault();
		const $target = $(e.currentTarget);
		const $dataSource = $target.hasClass("video__card") ? $target.find(".open-video-modal") : $target;
		const type = $dataSource.data("video-type");
		const id = $dataSource.data("video-id");
		const orientation = $target.attr("data-iframe-orientation") || "landscape";

		if (!type || !id) return;

		let src = "";
		if (type === "youtube") {
			src = `https://www.youtube.com/embed/${id}?autoplay=1&enable_js=1`;
		} else if (type === "vimeo") {
			src = `https://player.vimeo.com/video/${id}?autoplay=1`;
		}

		$(".video-modal__iframe-wrapper").html(`
			<iframe allow="autoplay" width="100%" height="415" class="video-modal__iframe video-modal__iframe--${orientation}" src="${src}" frameborder="0" allowfullscreen></iframe>
		`);

		$(".video-modal, .video-modal__overlay").fadeIn();
	}

	$(".open-video-modal").click(openVideo);
	$(".video__card").click(openVideo);
	$(".video-modal__close, .video-modal__overlay").click(() => closeVideoModal());
	$(document).keyup((e) => {
		if (e.which == 27) closeVideoModal();
	});
});